import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useGeriKapat } from '../ui/mobil';
import { useLocation } from 'react-router-dom';
import { api, tokens } from '../lib/api';
import { useAuth } from '../lib/auth';
import { sonHatalar } from './hataKancasi';

/**
 * SORUN BİLDİR — her sayfada yüzen "?" düğmesi (docs/SORUN-BILDIR-MIMARI.md).
 * Kullanıcı yalnız derdini yazar; ekran görüntüsü, adres, tarayıcı hataları ve
 * kim olduğu kendiliğinden eklenir.
 *  · Shadow DOM: panelin CSS'inden etkilenmez, ona da dokunmaz.
 *  · Kök öğede data-html2canvas-ignore: görüntüde widget'ın kendisi çıkmaz.
 *  · iframe içinde kurulmaz.
 *  · Kalıcı kararlar (tanıtım kartı) sunucuda; localStorage'da yalnız düğme konumu.
 */
type Baglam = {
  aktif: boolean; tanitim: boolean; azamiMb: number;
  kategoriler: { id: string; ad: string }[]; oncelikler: { id: string; ad: string }[]; hedefSure: Record<string, number>;
};
const BASLIK = { 'X-Requested-With': 'SorunBildir' };
const AZAMI_GORSEL = 5;

const CSS = `
:host { all: initial; }
* { box-sizing: border-box; font-family: 'DM Sans', system-ui, -apple-system, 'Segoe UI', Arial, sans-serif; }
.dugme { position: fixed; z-index: 2147483000; width: 46px; height: 46px; border-radius: 50%; border: 0; cursor: grab;
  background: #241F1C; color: #FAF7F3; font-size: 22px; font-weight: 700; box-shadow: 0 6px 20px rgba(0,0,0,.28); touch-action: none; }
.dugme:hover { background: #C2703F; }
.cubuk { position: fixed; left: 50%; bottom: 18px; transform: translateX(-50%); z-index: 2147483000; display: flex; align-items: center; gap: 12px;
  max-width: min(760px, calc(100vw - 32px)); background: #241F1C; color: #FAF7F3; border-radius: 12px; padding: 12px 14px 12px 16px;
  box-shadow: 0 14px 40px rgba(0,0,0,.35); font-size: 14px; line-height: 1.4; animation: cubuk-gel .28s ease-out; }
@keyframes cubuk-gel { from { opacity: 0; transform: translate(-50%, 16px); } to { opacity: 1; transform: translate(-50%, 0); } }
.cubuk-nokta { flex: 0 0 auto; width: 24px; height: 24px; border-radius: 50%; background: #2E7D4F; display: grid; place-items: center; font-size: 13px; font-weight: 700; }
.cubuk-metin { min-width: 0; }
.cubuk-yanit { color: #D9CFC6; }
.cubuk-btn { flex: 0 0 auto; background: #FAF7F3; color: #241F1C; border-radius: 8px; padding: 6px 12px; font-weight: 600; text-decoration: none; }
.cubuk-kapat { flex: 0 0 auto; background: none; border: 0; color: #B5A99F; font-size: 18px; cursor: pointer; padding: 0 4px; }
.rozet { position: absolute; top: -4px; right: -4px; min-width: 20px; height: 20px; padding: 0 5px; border-radius: 10px; background: #C0392B; color: #fff;
  font-size: 12px; font-weight: 700; line-height: 20px; text-align: center; box-shadow: 0 0 0 2px #FAF7F3; }
.tanitim { position: fixed; z-index: 2147483000; width: 290px; background: #FFFDFA; color: #241F1C; border: 1px solid #E3D9D1;
  border-left: 3px solid #C2703F; border-radius: 12px; padding: 14px 16px; box-shadow: 0 12px 32px rgba(0,0,0,.18); font-size: 14px; line-height: 1.45; }
.perde { position: fixed; inset: 0; z-index: 2147483001; background: rgba(20,17,16,.45); display: flex; align-items: flex-end; justify-content: flex-end; padding: 16px; }
.pencere { width: min(520px, 100%); max-height: calc(100vh - 32px); overflow: auto; background: #FFFDFA; color: #241F1C; border-radius: 16px;
  padding: 20px 22px; box-shadow: 0 24px 60px rgba(0,0,0,.35); font-size: 14px; }
h2 { margin: 0; font-size: 20px; font-weight: 600; }
.ust { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 12px; }
.alt { color: #6B625C; font-size: 13px; margin-top: 2px; }
label { display: block; font-weight: 600; font-size: 13px; margin: 12px 0 5px; }
input[type=text], textarea, select { width: 100%; border: 1px solid #D9CFC6; border-radius: 9px; padding: 9px 11px; font-size: 14px; background: #fff; color: #241F1C; }
textarea { min-height: 96px; resize: vertical; }
input:focus, textarea:focus, select:focus { outline: 2px solid #C2703F; outline-offset: 1px; }
.ikili { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.btn { border: 1px solid #D9CFC6; background: #fff; color: #241F1C; border-radius: 9px; padding: 8px 12px; font-size: 13px; font-weight: 600; cursor: pointer; }
.btn:hover { border-color: #241F1C; }
.btn[disabled] { opacity: .5; cursor: default; }
.btn.ana { background: #241F1C; color: #FAF7F3; border-color: #241F1C; padding: 11px 18px; font-size: 14px; }
.btn.yalin { border: 0; background: none; padding: 6px 8px; }
.sira { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; }
.kucukler { display: flex; gap: 8px; flex-wrap: wrap; margin-top: 8px; }
.kucuk { position: relative; width: 92px; height: 62px; border: 1px solid #D9CFC6; border-radius: 8px; overflow: hidden; background: #F1EAE2; }
.kucuk img { width: 100%; height: 100%; object-fit: cover; display: block; }
.kucuk button { position: absolute; top: 2px; right: 2px; width: 20px; height: 20px; border-radius: 50%; border: 0; background: rgba(36,31,28,.85); color: #fff; cursor: pointer; font-size: 12px; line-height: 1; }
.not { color: #6B625C; font-size: 12.5px; margin-top: 6px; line-height: 1.4; }
.hata { background: #FBE9E4; color: #8A2C1B; border-radius: 9px; padding: 9px 12px; margin-top: 12px; font-size: 13px; }
.tamam { background: #E7F3EA; color: #1F5C36; border-radius: 9px; padding: 12px 14px; font-size: 14px; }
.secici { position: fixed; inset: 0; z-index: 2147483002; cursor: crosshair; background: rgba(20,17,16,.25); }
.secici .kutu { position: fixed; border: 2px solid #C2703F; background: rgba(194,112,63,.15); }
.secici .ipucu { position: fixed; top: 14px; left: 50%; transform: translateX(-50%); background: #241F1C; color: #FAF7F3; padding: 8px 14px; border-radius: 9px; font-size: 13px; }
a { color: #9A4F25; }
/* Sabit öğeler alt gezinme çubuğunun (ve tam ekran katmanın eylem çubuğunun) üstünde durur: pay kabuktan gelir. */
.cubuk { bottom: calc(18px + var(--am-alt-pay, 0px)); }
/* Dar ekran (telefon + dikey tablet): alanlar 16 px (iOS odaklanınca yakınlaştırmasın), dokunma hedefi 44 px. */
@media (max-width: 900px) {
  input[type=text], textarea, select { font-size: 16px; min-height: 44px; }
  /* Safari yerel açılır listede yüksekliği yok sayar: görünüm sıfırlanır, ok elle çizilir. */
  select { -webkit-appearance: none; appearance: none; height: 44px; padding-right: 32px; text-overflow: ellipsis;
    background: #fff url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M3 4.5L6 7.5L9 4.5' stroke='%236B625C' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") no-repeat right 11px center; }
  .btn { min-height: 44px; min-width: 44px; padding: 0 14px; font-size: 14px; display: inline-flex; align-items: center; justify-content: center; }
  .btn.ana { min-height: 48px; font-size: 16px; }
  .kucuk button { width: 32px; height: 32px; font-size: 16px; }
  .kucuk button::after { content: ''; position: absolute; inset: -6px; }
  label:has(> input[type=checkbox]) { display: flex; align-items: center; gap: 10px; min-height: 44px; }
  input[type=checkbox] { width: 20px; height: 20px; flex: 0 0 auto; }
  .cubuk-btn, .cubuk-kapat { min-height: 44px; min-width: 44px; display: inline-flex; align-items: center; justify-content: center; }
}
/* Sol menü çekmecesi açıkken yüzen düğme menünün üstüne binmez (kabuk değişkeni ayarlar). */
.dugme, .tanitim { visibility: var(--am-sb-gorunum, visible); }
/* Telefon: pencere tam ekran sayfa. */
@media (max-width: 640px) {
  .perde { padding: 0; align-items: stretch; }
  .pencere { width: 100%; max-height: none; height: calc(100dvh - var(--ccd-klavye, 0px)); border-radius: 0; box-shadow: none;
    padding: 0 16px calc(16px + env(safe-area-inset-bottom, 0px)); overscroll-behavior: contain; }
  .ust { position: sticky; top: 0; z-index: 2; margin: 0 -16px 4px; padding: calc(10px + env(safe-area-inset-top, 0px)) 16px 10px; background: #FFFDFA; border-bottom: 1px solid #E3D9D1; align-items: center; }
  .ikili { grid-template-columns: 1fr; gap: 0; }
  .btn.ana { flex: 1 1 100%; }
  .cubuk { left: 12px; right: 12px; transform: none; max-width: none; animation: none; }
  .tanitim { width: min(290px, calc(100vw - 96px)); }
}
`;

/** html2canvas `overflow:hidden; nowrap` hücrelerde metni kırpmaz, komşunun üstüne basar (§7.1). */
function metinleriSigdir(belge: Document): void {
  const pencere = belge.defaultView;
  if (!pencere) return;
  belge.body.querySelectorAll<HTMLElement>('*').forEach((el) => {
    if (el.children.length > 0 || !el.textContent) return;
    const st = pencere.getComputedStyle(el);
    if (st.whiteSpace !== 'nowrap' || (st.overflowX !== 'hidden' && st.textOverflow !== 'ellipsis')) return;
    if (el.scrollWidth <= el.clientWidth + 1) return;
    const tam = el.textContent;
    let alt = 0, ust = tam.length;
    while (alt < ust) {
      const orta = Math.ceil((alt + ust) / 2);
      el.textContent = `${tam.slice(0, orta)}…`;
      if (el.scrollWidth <= el.clientWidth + 1) alt = orta; else ust = orta - 1;
    }
    el.textContent = alt >= tam.length ? tam : `${tam.slice(0, alt)}…`;
  });
}

async function sayfayiCiz(alan?: { x: number; y: number; w: number; h: number }): Promise<string> {
  const { default: html2canvas } = await import('html2canvas');
  const tuval = await html2canvas(document.body, {
    backgroundColor: '#ffffff', useCORS: true, logging: false, scale: Math.min(1.5, window.devicePixelRatio || 1),
    x: window.scrollX + (alan?.x ?? 0), y: window.scrollY + (alan?.y ?? 0),
    width: alan?.w ?? window.innerWidth, height: alan?.h ?? window.innerHeight,
    windowWidth: document.documentElement.clientWidth, windowHeight: window.innerHeight,
    onclone: (kopya) => metinleriSigdir(kopya),
  });
  return tuval.toDataURL('image/jpeg', 0.82);
}

/** Bu sekme seçili gelsin; tüm ekran / işletim sistemi izni istenmesin (§7.4). */
async function sekmeyiYakala(): Promise<string> {
  const akis = await navigator.mediaDevices.getDisplayMedia({
    video: { displaySurface: 'browser' } as MediaTrackConstraints, audio: false,
    preferCurrentTab: true, selfBrowserSurface: 'include', monitorTypeSurfaces: 'exclude', surfaceSwitching: 'exclude',
  } as DisplayMediaStreamOptions);
  try {
    const video = document.createElement('video');
    video.srcObject = akis; video.muted = true;
    await video.play();
    await new Promise((r) => setTimeout(r, 350));
    const tuval = document.createElement('canvas');
    tuval.width = video.videoWidth; tuval.height = video.videoHeight;
    tuval.getContext('2d')!.drawImage(video, 0, 0);
    return tuval.toDataURL('image/jpeg', 0.85);
  } finally { akis.getTracks().forEach((t) => t.stop()); }
}

const dosyadan = (f: File) => new Promise<string>((coz, red) => {
  const o = new FileReader(); o.onload = () => coz(String(o.result)); o.onerror = () => red(new Error('Dosya okunamadı')); o.readAsDataURL(f);
});
/** PNG/JPEG dışındaki ya da çok büyük görüntüyü JPEG'e çevirip küçültür. */
async function jpegeCevir(veri: string): Promise<string> {
  const img = new Image();
  await new Promise((coz, red) => { img.onload = coz; img.onerror = () => red(new Error('Görüntü açılamadı')); img.src = veri; });
  const oran = Math.min(1, 2200 / Math.max(img.width, img.height));
  const t = document.createElement('canvas');
  t.width = Math.round(img.width * oran); t.height = Math.round(img.height * oran);
  t.getContext('2d')!.drawImage(img, 0, 0, t.width, t.height);
  return t.toDataURL('image/jpeg', 0.85);
}

export default function SorunBildir() {
  const { me } = useAuth();
  const konum = useLocation();
  const [kok, setKok] = useState<ShadowRoot | null>(null);
  const [baglam, setBaglam] = useState<Baglam | null>(null);
  const [acik, setAcik] = useState(false);
  const [tanitim, setTanitim] = useState(false);
  const [yer, setYer] = useState<{ x: number; y: number }>(() => {
    try { const v = JSON.parse(localStorage.getItem('am_sb_yer') || 'null'); if (v && typeof v.x === 'number') return v; } catch { /* yok */ }
    return { x: 18, y: 18 };   // sağ alt köşeden uzaklık
  });
  const [baslik, setBaslik] = useState('');
  const [aciklama, setAciklama] = useState('');
  const [tur, setTur] = useState('');
  const [oncelik, setOncelik] = useState('NORMAL');
  const [gorseller, setGorseller] = useState<{ veri: string; otomatik?: boolean }[]>([]);
  const [otomatikEkle, setOtomatikEkle] = useState(true);
  const [mesgul, setMesgul] = useState<string | null>(null);
  const [hata, setHata] = useState<string | null>(null);
  const [sonuc, setSonuc] = useState<{ no: string } | null>(null);
  /* Bildirim: taleplerime gelen yeni yanıt/çözüm. Dakikada bir ve sayfa değişince bakılır.
     Her talep için alt çubuk oturum boyunca BİR KEZ çıkar; rozet görülene kadar kalır. */
  type Bildirim = { id: number; no: string; baslik: string; durum: string; yanit: string | null; tarih: string };
  const [bildirim, setBildirim] = useState<Bildirim[]>([]);
  const [cubuk, setCubuk] = useState<Bildirim | null>(null);
  const gosterilen = useRef<Set<string>>(new Set());
  useEffect(() => {
    if (!me) return;
    let iptal = false;
    const bak = () => api<{ talepler: Bildirim[] }>('/api/destek/bildirim').then((r) => {
      if (iptal) return;
      setBildirim(konum.pathname === '/destek' ? [] : r.talepler);
      const yeni = r.talepler.find((t) => !gosterilen.current.has(`${t.id}:${t.tarih}`));
      if (yeni && konum.pathname !== '/destek') { gosterilen.current.add(`${yeni.id}:${yeni.tarih}`); setCubuk(yeni); }
    }).catch(() => undefined);
    void bak();
    const t = setInterval(bak, 60_000);
    return () => { iptal = true; clearInterval(t); };
  }, [me, konum.pathname]);
  // Çubuk belirli süre sonra kendiliğinden kaybolur.
  useEffect(() => {
    if (!cubuk) return;
    const t = setTimeout(() => setCubuk(null), 12_000);
    return () => clearTimeout(t);
  }, [cubuk]);

  // Telefonun geri tuşu pencereyi kapatır (sayfadan çıkarmaz); gövde arkada kaymaz.
  useGeriKapat(acik, () => setAcik(false));

  const [secim, setSecim] = useState<null | { x0: number; y0: number; x1: number; y1: number; surukle: boolean }>(null);
  const surukleme = useRef<{ bx: number; by: number; x: number; y: number; oynadi: boolean } | null>(null);

  /* Shadow DOM kökü — yalnız en üst pencerede. */
  useEffect(() => {
    if (window.top !== window.self) return;
    const ev = document.createElement('div');
    ev.setAttribute('data-html2canvas-ignore', 'true');
    ev.id = 'am-sorun-bildir';
    document.body.appendChild(ev);
    setKok(ev.attachShadow({ mode: 'open' }));
    return () => { ev.remove(); };
  }, []);

  useEffect(() => {
    if (!me) return;
    api<Baglam>('/api/destek/baglam').then((b) => { setBaglam(b); setTanitim(b.tanitim); setTur(b.kategoriler[0]?.id ?? ''); }).catch(() => setBaglam(null));
  }, [me]);

  const gorselEkle = useCallback((veri: string, otomatik = false) => {
    setGorseller((g) => (g.length >= AZAMI_GORSEL ? g : [...g, { veri, otomatik }]));
  }, []);

  /* Pencere açılırken görünen ekranın görüntüsü kendiliğinden alınır. */
  async function ac() {
    setHata(null); setSonuc(null); setGorseller([]); setOtomatikEkle(true);
    setMesgul('Ekran görüntüsü alınıyor…');
    try { gorselEkle(await sayfayiCiz(), true); } catch { /* görüntüsüz de devam */ }
    setMesgul(null); setAcik(true);
    if (tanitim) tanitimKapat();
  }
  function tanitimKapat() {
    setTanitim(false);
    void api('/api/destek/tanitim-kapat', { method: 'POST', headers: BASLIK }).catch(() => undefined);
  }

  async function ekranAl() {
    setHata(null); setAcik(false);
    await new Promise((r) => setTimeout(r, 200));
    try { gorselEkle(await sekmeyiYakala()); }
    catch { try { gorselEkle(await sayfayiCiz()); } catch { setHata('Ekran görüntüsü alınamadı'); } }
    setAcik(true);
  }
  async function alanBitti(s: NonNullable<typeof secim>) {
    setSecim(null);
    const x = Math.min(s.x0, s.x1), y = Math.min(s.y0, s.y1), w = Math.abs(s.x1 - s.x0), h = Math.abs(s.y1 - s.y0);
    if (w < 12 || h < 12) { setAcik(true); return; }
    setMesgul('Seçilen alan çiziliyor…');
    try { gorselEkle(await sayfayiCiz({ x, y, w, h })); } catch { setHata('Alan görüntüsü alınamadı'); }
    setMesgul(null); setAcik(true);
  }
  async function dosyaSecildi(dosyalar: FileList | File[]) {
    for (const f of Array.from(dosyalar)) {
      if (!f.type.startsWith('image/')) { setHata('Yalnız görüntü dosyası eklenebilir'); continue; }
      try { gorselEkle(await jpegeCevir(await dosyadan(f))); } catch (e) { setHata((e as Error).message); }
    }
  }

  const otomatikBilgi = useMemo(() => () => {
    const gorunurHata = [...document.querySelectorAll('.ccd-banner-danger, .ccd-alert-danger, [role="alert"]')]
      .map((e) => (e.textContent ?? '').trim()).filter(Boolean).slice(0, 3);
    return {
      sayfa: document.title, adres: location.href, rota: konum.pathname,
      zaman: new Date().toLocaleString('tr-TR'), tarayici: navigator.userAgent,
      pencere: `${window.innerWidth}×${window.innerHeight}`, hatalar: sonHatalar(), gorunurHata,
    };
  }, [konum.pathname]);

  async function gonder(e: React.FormEvent) {
    e.preventDefault();
    if (baslik.trim().length < 3) { setHata('Kısaca ne olduğunu başlığa yazın'); return; }
    setHata(null); setMesgul('Gönderiliyor…');
    try {
      const secilen = gorseller.filter((g) => !g.otomatik || otomatikEkle);
      const adresler: string[] = [];
      for (const g of secilen) {
        const res = await fetch('/api/destek/gorsel', {
          method: 'POST',
          headers: { 'content-type': 'application/json', ...BASLIK, ...(tokens.access ? { authorization: `Bearer ${tokens.access}` } : {}) },
          body: JSON.stringify({ veri: g.veri }),
        });
        const j = await res.json().catch(() => ({}));
        if (!res.ok || !j.ok) throw new Error(j.mesaj || j.error || 'Görüntü yüklenemedi');
        adresler.push(j.url);
      }
      const r = await api<{ no: string }>('/api/destek', {
        method: 'POST', headers: BASLIK,
        body: JSON.stringify({ baslik: baslik.trim(), aciklama: aciklama.trim(), tur, oncelik, baglam: otomatikBilgi(), gorseller: adresler }),
      });
      setSonuc({ no: r.no }); setBaslik(''); setAciklama(''); setGorseller([]);
    } catch (err) {
      setHata(`${err instanceof Error ? err.message : 'Gönderilemedi'} — yazdıklarınız duruyor, yeniden deneyin.`);
    } finally { setMesgul(null); }
  }

  if (!kok || !me || !baglam?.aktif) return null;
  const hedefGun = baglam.hedefSure[oncelik];
  const sag = Math.max(8, Math.min(window.innerWidth - 54, yer.x));
  const alt = Math.max(8, Math.min(window.innerHeight - 54, yer.y));

  return createPortal(
    <>
      <style>{CSS}</style>
      {!acik && !secim && (
        <button className="dugme" style={{ right: sag, bottom: `calc(${alt}px + var(--am-alt-pay, 0px))` }} title="Sorun bildir — ekran görüntüsü kendiliğinden eklenir" aria-label="Sorun bildir"
          onPointerDown={(e) => { surukleme.current = { bx: e.clientX, by: e.clientY, x: yer.x, y: yer.y, oynadi: false }; (e.target as HTMLElement).setPointerCapture(e.pointerId); }}
          onPointerMove={(e) => {
            const s = surukleme.current; if (!s) return;
            const dx = e.clientX - s.bx, dy = e.clientY - s.by;
            if (Math.abs(dx) + Math.abs(dy) > 5) s.oynadi = true;
            if (s.oynadi) setYer({ x: s.x - dx, y: s.y - dy });
          }}
          onPointerUp={() => {
            const s = surukleme.current; surukleme.current = null;
            if (s?.oynadi) { try { localStorage.setItem('am_sb_yer', JSON.stringify(yer)); } catch { /* önemsiz */ } }
            else void ac();
          }}>{mesgul && !acik ? '…' : '?'}{bildirim.length > 0 && <span className="rozet" aria-label={`${bildirim.length} yeni yanıt`}>{bildirim.length}</span>}</button>
      )}

      {/* Alt bildirim çubuğu: hangi ekranda olursa olsun çıkar, 12 saniye sonra kendiliğinden kaybolur.
          Rozet (düğmedeki sayı) talep görülene kadar kalır. */}
      {cubuk && !acik && !secim && (
        <div className="cubuk" role="status" aria-live="polite">
          <span className="cubuk-nokta" aria-hidden="true">✓</span>
          <span className="cubuk-metin">
            <b>{cubuk.durum === 'COZULDU' ? 'Talebiniz yapılmıştır' : 'Talebinize yanıt var'}</b>
            {' · '}{cubuk.no} — {cubuk.baslik}
            {cubuk.yanit && <span className="cubuk-yanit"> · {cubuk.yanit.length > 110 ? `${cubuk.yanit.slice(0, 110)}…` : cubuk.yanit}</span>}
          </span>
          <a className="cubuk-btn" href="/destek">Göster</a>
          <button className="cubuk-kapat" aria-label="Bildirimi kapat" onClick={() => setCubuk(null)}>×</button>
        </div>
      )}

      {tanitim && !acik && !secim && (
        <div className="tanitim" style={{ right: sag + 56, bottom: `calc(${alt}px + var(--am-alt-pay, 0px))` }}>
          <b>Bir şey ters giderse buraya basın.</b>
          <div style={{ margin: '6px 0 10px' }}>Derdinizi iki cümleyle yazın; ekran görüntüsü ve hangi sayfada olduğunuz kendiliğinden eklenir.</div>
          <button className="btn" onClick={tanitimKapat}>Anladım</button>
        </div>
      )}

      {secim && (
        <div className="secici"
          onPointerDown={(e) => setSecim({ x0: e.clientX, y0: e.clientY, x1: e.clientX, y1: e.clientY, surukle: true })}
          onPointerMove={(e) => { if (secim.surukle) setSecim({ ...secim, x1: e.clientX, y1: e.clientY }); }}
          onPointerUp={() => { if (secim.surukle) void alanBitti(secim); }}>
          <div className="ipucu">Göstermek istediğiniz alanı sürükleyerek seçin · vazgeçmek için tıklayıp bırakın</div>
          {secim.surukle && <div className="kutu" style={{ left: Math.min(secim.x0, secim.x1), top: Math.min(secim.y0, secim.y1), width: Math.abs(secim.x1 - secim.x0), height: Math.abs(secim.y1 - secim.y0) }} />}
        </div>
      )}

      {acik && (
        <div className="perde" onClick={() => !mesgul && setAcik(false)}>
          <div className="pencere" role="dialog" aria-modal="true" aria-label="Sorun bildir" onClick={(e) => e.stopPropagation()}
               onPaste={(e) => { const f = [...e.clipboardData.files].filter((x) => x.type.startsWith('image/')); if (f.length) { e.preventDefault(); void dosyaSecildi(f); } }}>
            <div className="ust">
              <div><h2>Sorun bildir</h2><div className="alt">Sayfa, zaman ve tarayıcı bilgisi kendiliğinden eklenir.</div></div>
              <button className="btn yalin" onClick={() => setAcik(false)} disabled={!!mesgul}>Kapat</button>
            </div>
            {sonuc ? (
              <>
                <div className="tamam"><b>{sonuc.no}</b> numaralı talebiniz açıldı. Yanıtı <a href="/destek">Destek Talepleri</a> ekranında görürsünüz.</div>
                <div className="sira" style={{ marginTop: 14 }}>
                  <button className="btn ana" onClick={() => setAcik(false)}>Tamam</button>
                  <button className="btn" onClick={() => setSonuc(null)}>Yeni talep</button>
                </div>
              </>
            ) : (
              <form onSubmit={gonder}>
                <label htmlFor="sb-baslik">Ne oldu? (kısaca)</label>
                <input id="sb-baslik" type="text" value={baslik} maxLength={160} autoFocus placeholder="Örn. Teklifi kaydedince hata veriyor"
                       onChange={(e) => setBaslik(e.target.value)} />
                <label htmlFor="sb-aciklama">Ayrıntı (isteğe bağlı)</label>
                <textarea id="sb-aciklama" value={aciklama} maxLength={8000} placeholder="Ne yapmaya çalışıyordunuz, ne bekliyordunuz, ne oldu?"
                          onChange={(e) => setAciklama(e.target.value)} />
                <div className="ikili">
                  <div><label htmlFor="sb-tur">Tür</label>
                    <select id="sb-tur" value={tur} onChange={(e) => setTur(e.target.value)}>
                      {baglam.kategoriler.map((k) => <option key={k.id} value={k.id}>{k.ad}</option>)}</select></div>
                  <div><label htmlFor="sb-onc">Öncelik</label>
                    <select id="sb-onc" value={oncelik} onChange={(e) => setOncelik(e.target.value)}>
                      {baglam.oncelikler.map((k) => <option key={k.id} value={k.id}>{k.ad}</option>)}</select></div>
                </div>
                {hedefGun != null && <div className="not">Hedef süre: {hedefGun === 0 ? 'aynı gün' : `${hedefGun} iş günü`}</div>}

                <label>Görüntüler ({gorseller.filter((g) => !g.otomatik || otomatikEkle).length}/{AZAMI_GORSEL})</label>
                <div className="sira">
                  <button type="button" className="btn" disabled={gorseller.length >= AZAMI_GORSEL} onClick={() => { setAcik(false); setSecim({ x0: 0, y0: 0, x1: 0, y1: 0, surukle: false }); }}>Alan seç</button>
                  <button type="button" className="btn" disabled={gorseller.length >= AZAMI_GORSEL} onClick={() => void ekranAl()}>Ekran görüntüsü al</button>
                  <label className="btn" style={{ margin: 0 }}>Dosya ekle
                    <input type="file" accept="image/*" multiple hidden onChange={(e) => { if (e.target.files) void dosyaSecildi(e.target.files); e.target.value = ''; }} /></label>
                </div>
                {gorseller.some((g) => g.otomatik) && (
                  <label style={{ fontWeight: 400, margin: '8px 0 0' }}>
                    <input type="checkbox" checked={otomatikEkle} onChange={(e) => setOtomatikEkle(e.target.checked)} /> Açılışta alınan ekran görüntüsünü ekle
                  </label>
                )}
                <div className="kucukler">
                  {gorseller.map((g, n) => (!g.otomatik || otomatikEkle) && (
                    <div key={n} className="kucuk"><img src={g.veri} alt={`Görüntü ${n + 1}`} />
                      <button type="button" aria-label="Görüntüyü kaldır" onClick={() => setGorseller((x) => x.filter((_, i) => i !== n))}>×</button></div>
                  ))}
                </div>
                <div className="not">Kopyaladığınız görüntüyü bu pencereye Ctrl+V ile yapıştırabilirsiniz. Görüntüleri yalnız siz ve yöneticiler açabilir.</div>

                {hata && <div className="hata">{hata}</div>}
                <div className="sira" style={{ marginTop: 16 }}>
                  <button className="btn ana" disabled={!!mesgul}>{mesgul ?? 'Gönder'}</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </>,
    kok as unknown as Element,
  );
}
